module.exports = __webpack_public_path__ + "static/media/requestrr_white.f2092d29.svg";